import { saleForms } from '@/shared/config/expiration-forms';

export const insuranceCompaniesStatisticTypes = [
  { value: 'amount', label: 'Проданих полісів страхових компаній  ₴', description: 'Цього місяця ви здійснили продажів на суму', },
  { value: 'count', label: 'Проданих полісів страхових компаній ШТ', description: 'Цього місяця ви здійснили', expiration_forms: saleForms.forms, },
  { value: 'earnings', label: 'Комісійні винагороди по страхових компаніях ₴', description: 'Цього місяця ви заробили', },
];
